import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './Components/Styling/mainBig.css';

ReactDOM.render(<App />, document.getElementById('root'));